import { cn } from '@/shared/lib'
import { useNoiseStatus } from '../model/noise-status'
import { useNoiseSuppression } from '../model/noise-store'

const LABEL: Record<string, string> = {
  pending: 'Шумодав: ожидает микрофон',
  loading: 'Шумодав: включается…',
  active: 'Шумодав активен',
  unsupported: 'Шумодав не поддерживается',
  failed: 'Шумодав не работает',
}

// Бейдж на звонке: виден только при включённом тумблере и отражает
// ФАКТИЧЕСКОЕ состояние обработки, а не желание пользователя.
export function NoiseSuppressionBadge() {
  const enabled = useNoiseSuppression((s) => s.enabled)
  const status = useNoiseStatus()
  if (!enabled || status === 'off') return null

  const broken = status === 'failed' || status === 'unsupported'
  return (
    <span
      role="status"
      className={cn(
        'inline-flex items-center gap-2 rounded-pill border px-3 py-1 font-mono text-xs uppercase tracking-wide',
        broken ? 'border-border-accent text-accent' : 'border-border-default text-text-secondary',
      )}
    >
      <span
        aria-hidden
        className={cn(
          'h-2 w-2 rounded-pill',
          status === 'active' && 'bg-success',
          (status === 'loading' || status === 'pending') && 'dot-pulse bg-warning',
          broken && 'bg-accent',
        )}
      />
      {LABEL[status]}
    </span>
  )
}
